/* LD 2026-10-24 (Niko, "implement suggestion", G): ADD TO CART waits for the Easify configurator.
   KEEP THIS BLOCK FIRST IN THE FILE. A ring's button comes disabled in the server HTML and only this block
   enables it, so if it ran after the other blocks, an exception thrown by any of them while the file runs
   would stop it too and leave every ring unbuyable. As the file's first statement it is set up before any
   other code here runs (round 1, 2026-10-24; checked by docs/atc-gate-2026-10-24/test/gate-isolation.js).
   snippets/product-form-contents.liquid renders the button of every product the gate covers (see there)
   disabled (the attribute, the theme's .disabled class, aria-disabled, aria-describedby -> the visually hidden
   reason of snippets/ld-atc-gate.liquid, and data-ld-atc-gate, which that snippet's style dims), and wraps a
   dynamic checkout button, if one is ever switched on, in an inert [data-ld-atc-gate-spb]. The raw section
   HTML (?section_id= / ?sections=) and a browser without JavaScript run no script, so there the button stays
   disabled: a bare ring cannot be sent to the cart from it. Fail closed: no timeout enables it.
   This enables a gated button once Easify has rendered its option set FOR THAT BUTTON: Easify's render
   function sets data-is-render-option-set="true" on the add-to-cart button it renders for, last, after it
   has bound its add-to-cart click handler and its validator to that very element (checked in
   product-options-*.js of easify-product-options-2079, 2026-10-24). Easify clones the button before that
   (cloneAddToCart) and the clone keeps every attribute, so the element it binds is the gated one - the
   button is always looked up again, never kept. Fallback for an Easify that stops setting that attribute:
   after its own load events (tpo_loaded, easify:loaded, which it fires once its sets are rendered), a gated
   button whose product area holds Easify's rendered options (.tpo_option-container). Easify's required-
   field check is untouched: it runs in its own click handler, which the browser only calls on an enabled
   button. While a button is still gated, a script that enables it (atlantic.js does on a variant switch) is
   undone in the observer callback, before the next paint and before any click can reach it. Released
   once; from then on the theme and Easify own the button as before. A multi-variant product whose selected
   variant is sold out (its option disabled) keeps the button disabled; there is none today.
   Still gated 10 s after this block first saw the button (Easify blocked, failed or changed): the snippet's
   note "The options of this ring have not loaded. Please reload the page, or write to us ..." is put into
   its role="status" region under the button, so the customer is told; the button stays disabled, and a
   later release removes the note with the reason.
   Watches the whole document (Easify renders the quickshop and its re-renders later), the callback only
   reads [data-ld-atc-gate] and writes only where the state differs, so it cannot feed itself. Marks
   performance 'ld-atc-gate-released' for the timing checks of docs/atc-gate-2026-10-24. */
(function () {
	var GATE = 'data-ld-atc-gate';
	var LATE = 'data-ld-atc-gate-late';
	var SINCE = 'data-ld-atc-gate-since';
	var LATE_MS = 10000;
	var loaded = false;

	function clock() {
		return window.performance && typeof performance.now === 'function' ? performance.now() : Date.now();
	}

	function area(btn) {
		return btn.closest('.product-area') || btn.closest('form') || document;
	}

	function soldOut(btn) {
		var form = btn.form || btn.closest('form');
		var select = form && form.querySelector('select[name="id"]');
		var option = select && select.options[select.selectedIndex];
		return !!(option && option.disabled);
	}

	function ready(btn) {
		if (btn.getAttribute('data-is-render-option-set') === 'true') return true;
		return loaded && !!area(btn).querySelector('.tpo_option-container');
	}

	function gateId(btn) {
		var id = btn.getAttribute('aria-describedby');
		return id && id.indexOf('ld-atc-gate-') === 0 ? id : null;
	}

	function remove(el) {
		if (el && el.parentNode) el.parentNode.removeChild(el);
	}

	function wake(note) {
		var wait = Number(note.getAttribute(SINCE)) + LATE_MS - clock();
		if (wait > 0) {
			setTimeout(function () { wake(note); }, wait + 20);
		} else {
			check();
		}
	}

	function late(btn) {
		var id = gateId(btn);
		var note = id && document.getElementById(id + '-late');
		if (!note || note.getAttribute(LATE) === 'shown') return;
		if (!note.hasAttribute(SINCE)) {
			note.setAttribute(SINCE, String(Math.round(clock())));
			wake(note);
			return;
		}
		if (clock() - Number(note.getAttribute(SINCE)) < LATE_MS) return;
		var tpl = note.querySelector('template');
		note.setAttribute(LATE, 'shown');
		if (tpl && tpl.content) note.appendChild(tpl.content.cloneNode(true));
	}

	function release(btn) {
		var scope = area(btn);
		var id = gateId(btn);
		btn.removeAttribute(GATE);
		btn.removeAttribute('aria-disabled');
		if (id) {
			btn.removeAttribute('aria-describedby');
			remove(document.getElementById(id));
			remove(document.getElementById(id + '-late'));
		}
		if (!soldOut(btn)) {
			btn.classList.remove('disabled');
			btn.disabled = false;
		}
		Array.prototype.forEach.call(scope.querySelectorAll('[data-ld-atc-gate-spb]'), function (wrap) {
			wrap.removeAttribute('inert');
			wrap.removeAttribute('data-ld-atc-gate-spb');
		});
		if (window.performance && typeof performance.mark === 'function') performance.mark('ld-atc-gate-released');
	}

	function check() {
		var gated = document.querySelectorAll('[' + GATE + ']');
		Array.prototype.forEach.call(gated, function (btn) {
			if (ready(btn)) {
				release(btn);
			} else {
				if (!btn.disabled) btn.disabled = true;
				if (!btn.classList.contains('disabled')) btn.classList.add('disabled');
				late(btn);
			}
		});
	}

	function onLoaded() {
		loaded = true;
		check();
		setTimeout(check, 0);
	}

	check();
	document.addEventListener('tpo_loaded', onLoaded);
	document.addEventListener('easify:loaded', onLoaded);
	if (typeof MutationObserver !== 'undefined') {
		new MutationObserver(check).observe(document.documentElement, {
			subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'data-is-render-option-set']
		});
	} else {
		var tries = 0;
		var poll = setInterval(function () {
			tries += 1;
			check();
			if (tries > 120) clearInterval(poll);
		}, 250);
	}
})();


/* Hides non-selected gold option thumbnails.
   Matches on data-media-alt (raw English media alt, e.g. "Gold color") so it
   is independent of the storefront language — aria-labels are localized and
   must NOT be parsed for this. */
function filterThumbnails() {
	var thumbnailNodes = document.getElementsByClassName('product-gallery--media-thumbnail');
	if (!thumbnailNodes.length) {
		return;
	}

	var selectedKey;
	var selectedNode = document.querySelector('button[data-product-gallery-selected=true]');
	if (selectedNode && selectedNode.dataset.mediaAlt) {
		/* "Gold color" -> "Gold"; alts are English by policy */
		selectedKey = selectedNode.dataset.mediaAlt.replace(/\bcolor\b/i, '').replace(/\s+/g, ' ').trim();
	}

	Array.from(thumbnailNodes).forEach(function (node) {
		if (!selectedKey || !node.dataset.mediaAlt) {
			node.hidden = false; /* fail open: show all rather than hide wrongly */
		} else {
			node.hidden = node.dataset.mediaAlt.indexOf(selectedKey) === -1;
		}
	});
}

/* Gallery follows the metal selection in every storefront language.
   Easify's own image sync matches its option value text against media — that
   only works in English (values are translated per locale, media alts are not).
   This bridge detects a metal-swatch click by language-independent tokens,
   maps it to the English alt keyword, and clicks the matching gallery
   thumbnail so the theme's own selection code runs; then re-filters. */
(function () {
	function metalAltKeyword(value) {
		if (!value) return null;
		if (/platin/i.test(value)) return 'Platinum';
		/* LD 2026-09-07: the Easify metal values dropped the karat ("White Gold", "Weißgold", "Or blanc", "Oro bianco",
		   "Oro blanco", "Bijelo zlato"), so gold is recognised by a gold word in any storefront language; "18K" is
		   still accepted for any translation that keeps it. Stone names (Blanc Éternel, Rose Poudré, ...) match none. */
		if (!/gold|zlat|\boro\b|\bor\b|18\s*k/i.test(value)) return null;
		/* LD 2026-09-07: media alts no longer carry the karat ("White Gold color", not "18K White Gold color") */
		if (/wei|white|blanc|bianco|blanco|bijel/i.test(value)) return 'White Gold';
		if (/gelb|yellow|jaune|giallo|amarillo|[žz]ut/i.test(value)) return 'Yellow Gold';
		if (/ros|roz|ruž/i.test(value)) return 'Rose Gold'; /* rose/roze/rozo/ružičasto */
		return null;
	}

	/* Swatch captions: Easify's injected CSS keys tile captions on the ENGLISH
	   option values, so renamed stone colors and translated values lose theirs.
	   Set data-ld-caption from the (localized) input value; theme.css.liquid
	   renders it via content: attr(). Where the original English-keyed rules
	   still match they win the cascade, so English pages are unchanged. */
	function applyCaptions() {
		var squares = document.querySelectorAll('.tpo_shape_square');
		Array.prototype.forEach.call(squares, function (sq) {
			/* one-time cleanup: an earlier version captioned sold-out values
			   whose value attr embeds Easify's <span> markup */
			if (sq.dataset.ldCaption && sq.dataset.ldCaption.indexOf('<') !== -1) {
				delete sq.dataset.ldCaption;
			}
			var input = sq.querySelector('input');
			var raw = input && input.value;
			if (!raw || sq.dataset.ldCaption) return;
			/* Easify appends its sold-out suffix as markup INSIDE the value attr
			   ("2.50 CT <span class=\"tpo_sold_out_…\">…</span>") — strip tags
			   before any classification, and never caption from markup. */
			var v = raw.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
			if (!v) return;
			if (/^[\d.,]+(\s*ct)?\b/i.test(v)) return; /* carat / ring-size tiles (incl. sold-out-suffixed) — no captions */
			if (/^(yes|ja|oui|s[ìí]|da)$/i.test(v)) return; /* agreement toggles */
			var caption = v;
			if (metalAltKeyword(v)) {
				caption = v.replace(/\s*18\s*K\s*/i, ' ').replace(/\s+/g, ' ').trim();
			} else if (/^(Blanc Éternel|Rose Poudré|Bleu Royal|Jaune Champagne|Vert Impérial)$/.test(v)) {
				caption = v.split(' ')[0]; /* short brand names on tiles, per original design */
			}
			/* capitalize the first letter — stripping "18K " can leave a
			   lowercase adjective (Croatian "bijelo zlato" → "Bijelo zlato") */
			caption = caption.charAt(0).toUpperCase() + caption.slice(1);
			sq.dataset.ldCaption = caption;
		});
	}

	function selectThumbForKey(key) {
		if (!key) return false;
		var thumbs = document.getElementsByClassName('product-gallery--media-thumbnail');
		var target = Array.prototype.find.call(thumbs, function (t) {
			/* contains, not starts-with: tolerates an alt that still carries a leading karat */
			return (t.dataset.mediaAlt || '').indexOf(key) !== -1;
		});
		if (!target) return false;
		if (target.dataset.productGallerySelected !== 'true') {
			target.click(); /* drives the theme's _selectMediaByIndex */
		}
		filterThumbnails();
		return true;
	}

	document.addEventListener('click', function (ev) {
		var square = ev.target.closest && ev.target.closest('.tpo_shape_square');
		if (!square) return;
		/* let Easify finish its own selection handling first */
		setTimeout(function () {
			var input = square.querySelector('input');
			if (!selectThumbForKey(metalAltKeyword(input && input.value))) {
				filterThumbnails();
			}
			applyCaptions(); /* Easify re-renders conditional pickers on selection */
		}, 60);
	}, true);

	/* On-load sync: Easify pre-checks a metal (saved/default selection) but its
	   own value→image match fails outside English, leaving the gallery on the
	   first media. Align the gallery with the checked metal once pickers load. */
	function syncGalleryToCheckedMetal() {
		var radios = document.querySelectorAll('.tpo_shape_square input[type=radio]');
		var checked = Array.prototype.find.call(radios, function (r) {
			return r.checked && metalAltKeyword(r.value);
		});
		if (!checked) return false;
		return selectThumbForKey(metalAltKeyword(checked.value));
	}

	document.addEventListener('tpo_loaded', function () {
		setTimeout(function () {
			applyCaptions();
			syncGalleryToCheckedMetal();
		}, 100);
	});
	/* Easify may restore the saved selection shortly after tpo_loaded — retry briefly */
	var tries = 0;
	var poll = setInterval(function () {
		tries += 1;
		applyCaptions();
		if (syncGalleryToCheckedMetal() || tries > 10) clearInterval(poll);
	}, 700);
})();

/* Stone-photo note — product photos show the ring with the stone shape named
   in its title (titles stay English in every locale), in the default color and
   carat — while Easify always preselects Round. Reveals [data-ld-stone-note]
   when the selected stone differs from the pictured one: shape groups compare
   against data-ld-pictured-shape via the checked swatch's image filename
   (white_marquise_….png — locale-proof, option values are translated). Color
   compares against data-ld-pictured-color (english filename token, from
   product.metafields.lediameve.pictured_color) when set, else against the
   initial selection; carat likewise against data-ld-pictured-carat (numeric)
   or the initial selection (LD 2026-08-20: metafield overrides added so the
   note reacts to the pictured stone, not the configurator defaults). The metal group is
   excluded (gallery thumbnails already follow the metal choice); it is
   recognized by its values, which contain a metal word in every locale.
   LD 2026-10-22: the same pass reveals [data-ld-east-west-note] (east-west rings,
   R006) while the visible shape swatch is none of its data-ld-ew-shapes. */
(function () {
	const METAL_RE = /gold|platin|zlat|\boro\b|\bor\b/i;
	const STONE_COLOR_RE = /Blanc Éternel|Rose Poudré|Bleu Royal|Jaune Champagne|Vert Impérial|\bGreen\b/i;
	let initial = null;
	let bound = false;

	function optionGroups() {
		const groups = {};
		document.querySelectorAll('.easify-product-options input[type="radio"]').forEach(radio => {
			if (!radio.name) return;
			(groups[radio.name] = groups[radio.name] || []).push(radio);
		});
		Object.keys(groups).forEach(name => {
			if (groups[name].some(r => METAL_RE.test(r.value))) delete groups[name];
		});
		return groups;
	}

	function isShapeGroup(radios, wrapper) {
		if (!wrapper || wrapper.className.indexOf('image-swatches') === -1) return false;
		return !radios.some(r => STONE_COLOR_RE.test(r.value));
	}

	function caratOf(value) {
		const m = /(\d+[.,]\d+)/.exec(value || '');
		return m ? m[1].replace(',', '.') : '';
	}

	function evaluate() {
		const groups = optionGroups();
		const note = document.querySelector('[data-ld-stone-note]');
		const pictured = note && note.dataset.ldPicturedShape;
		const picturedColor = note && note.dataset.ldPicturedColor;
		const picturedCarat = note && note.dataset.ldPicturedCarat ? note.dataset.ldPicturedCarat.replace(',', '.') : '';
		let differs = false;
		let shapeFile = '';
		Object.keys(groups).forEach(name => {
			const checked = groups[name].find(r => r.checked);
			if (!checked) return;
			const wrapper = checked.closest('[class*="tpo_option-type-"]');
			if (wrapper && !wrapper.offsetParent) return; // hidden conditional group
			const isSwatch = wrapper && wrapper.className.indexOf('image-swatches') !== -1;
			if (isShapeGroup(groups[name], wrapper)) {
				const label = checked.closest('label');
				const img = label && label.querySelector('img');
				const file = img && img.src ? img.src.split('/').pop().toLowerCase() : '';
				if (file) shapeFile = file;
				if (pictured && file) {
					// swatch files are <color>_<shape>_<uuid>… — uuids never contain underscores
					if (file.indexOf('_' + pictured + '_') === -1) differs = true;
					return;
				}
				// no pictured shape or no swatch image (markup change) — fall back to initial compare below
			}
			// LD 2026-08-20: color group vs the PICTURED color (filename token, locale-proof)
			if (picturedColor && isSwatch && groups[name].some(r => STONE_COLOR_RE.test(r.value))) {
				const label = checked.closest('label');
				const img = label && label.querySelector('img');
				const file = img && img.src ? img.src.split('/').pop().toLowerCase() : '';
				if (file) {
					if (file.indexOf(picturedColor + '_') !== 0) differs = true;
					return;
				}
			}
			// LD 2026-08-20: carat group vs the PICTURED carat (numeric, locale-proof)
			const carat = caratOf(checked.value);
			if (picturedCarat && carat) {
				if (parseFloat(carat) !== parseFloat(picturedCarat)) differs = true;
				return;
			}
			if (!(name in initial)) { initial[name] = checked.value; return; }
			if (checked.value !== initial[name]) differs = true;
		});
		document.querySelectorAll('[data-ld-stone-note]').forEach(n => {
			n.hidden = !differs;
		});
		// LD 2026-10-22: east-west rings only sit east-west with an elongated stone;
		// an unknown shape (no swatch image) keeps the note hidden.
		document.querySelectorAll('[data-ld-east-west-note]').forEach(n => {
			const shapes = (n.dataset.ldEwShapes || '').split(',');
			n.hidden = !shapeFile || shapes.some(shape => shapeFile.indexOf('_' + shape + '_') !== -1);
		});
	}

	function scheduleEvaluate(event) {
		if (!event.target.closest || !event.target.closest('.easify-product-options')) return;
		// Two passes: Easify's conditional show/hide is async, and a single early
		// read can see a stale wrapper visibility and freeze the note wrong.
		setTimeout(evaluate, 50);
		setTimeout(evaluate, 450);
	}

	let mutationTimer = null;
	function onMutation() {
		clearTimeout(mutationTimer);
		mutationTimer = setTimeout(evaluate, 100);
	}

	function init() {
		if (bound || !document.querySelector('[data-ld-stone-note]')) return;
		const groups = optionGroups();
		if (!Object.keys(groups).length) return;
		bound = true;
		initial = {};
		Object.keys(groups).forEach(name => {
			const checked = groups[name].find(r => r.checked);
			if (checked) initial[name] = checked.value;
		});
		document.addEventListener('change', scheduleEvaluate, true);
		document.addEventListener('click', scheduleEvaluate, true);
		// Safety net for changes that fire no event here (programmatic resets,
		// deferred conditional toggles): the note sits outside these containers,
		// so re-evaluating on their mutations cannot loop.
		const observer = new MutationObserver(onMutation);
		document.querySelectorAll('.easify-product-options').forEach(container => {
			observer.observe(container, { subtree: true, attributes: true, attributeFilter: ['class', 'style'], childList: true });
		});
		// The pictured shape may differ from Easify's Round default, so the
		// note can be due right at page load.
		evaluate();
	}

	document.addEventListener('tpo_loaded', () => setTimeout(init, 0));
	let tries = 0;
	const poll = setInterval(() => {
		tries += 1;
		if (bound || tries > 40) { clearInterval(poll); return; }
		init();
	}, 500);
})();

/* LD: "€ 1.234,00" — a non-breaking space between the euro sign and the amount,
   client-side (2026-09-03). The theme renders every amount with that space itself
   (snippets/ld-eur.liquid), and its own scripts reformat with the spaced money_format
   the sections hand them. The writer the theme cannot feed is the Easify Product
   Options app: it formats with the glued shop.money_format it embeds in its own
   TPOConfigs.shop (checked on Easify's demo store) and rewrites amounts after load —
   the configured total on the product page (it clones the .money--last span), and
   line totals in the cart table and the cart drawer (seen live on the cart page, where
   only that cell stayed "€1.140,00"). So those three roots are watched and any "€"
   glued to a digit is split after the fact; that also spaces the "[ +€150,00 ]" the app
   stores in line-item property text. Observer callbacks run before the next paint, so
   the glued string is never shown. Idempotent: the rewrite never matches its own output,
   so the observer cannot feed itself. Roots that persist across the theme's own
   rewrites: the cart page's form[data-cart-form] (morphdom patches the table inside
   it) and the layout's [data-sidebar-drawer] (the drawer's content is injected into
   it). Re-bound on shopify:section:load because a theme-editor section reload replaces
   the product panel node; the storefront never fires that event. */
(function () {
	if (typeof MutationObserver === 'undefined') return;
	var ROOTS = ['.product__price.ld-price-panel', 'form[data-cart-form]', '[data-sidebar-drawer]'];
	var observers = [];
	function split(root) {
		var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
		var node;
		while ((node = walker.nextNode())) {
			var fixed = node.nodeValue.replace(/€(?=\d)/g, '€\u00a0');
			if (fixed !== node.nodeValue) node.nodeValue = fixed;
		}
	}
	function bind() {
		observers.forEach(function (o) { o.disconnect(); });
		observers = [];
		ROOTS.forEach(function (selector) {
			Array.prototype.forEach.call(document.querySelectorAll(selector), function (root) {
				split(root);
				var observer = new MutationObserver(function () { split(root); });
				observer.observe(root, { subtree: true, childList: true, characterData: true });
				observers.push(observer);
			});
		});
	}
	bind();
	document.addEventListener('shopify:section:load', bind);
})();

/* LD 2026-10-23: "From" price until a stone is chosen, on centre-stone ring product pages.
   Easify preselects metal, stone colour and shape but no carat - Shopify allows no preselected
   option that carries a price - so its Total showed the bare setting (R003 €790), a price no
   complete ring has. snippets/product.liquid sends "From €970" (setting + the default stone)
   and keeps the theme's .money--last span at the bare price, because Easify reads its base
   price from that span's text; it marks the panel (data-ld-from-delta, -base,
   -not-stone-products, -money-format). Which caption and amount show is decided in CSS
   (assets/theme.css.liquid, "From" state machine): once Easify is in, its own Total shows
   unless this sets .ld-from-mode - so if this never runs, the real total shows, never a stale
   From.
   The From amount follows the selection: Easify's total + the cheapest stone the customer can
   still pick in the carat picker on show (enabled buttons only - a sold-out size is disabled
   with a €1,00 placeholder - priced from the tooltip Easify renders next to each button), so a
   Pink Round reads "From €1.530", not €970 (UCPD: a "from" price must be obtainable for what
   is selected). The stone pickers are Easify button pickers whose inputs link an add-on
   product (data-product-id) that is not one of the two Platinum products; a stone is chosen
   when one of them is checked in a picker on show (after a shape change the old shape's carat
   stays checked in its hidden picker, and Easify leaves it out of the total), or, as a
   fallback, when the total is at least the cheapest stone above the variant price. No carat
   price readable: the server's delta (the shop's default stone). Never writes into the app's
   span; it only writes its own amount when the text changes, compared after the euro-space
   splitter above has had its say, so the two observers cannot feed each other.
   LD 2026-10-23 (Niko): when the carat picker on show has sizes but none on sale (every input
   disabled: the colour is not offered in this shape, e.g. R003 Jaune Champagne + Princess), no
   amount can be bought, so the panel gets .ld-none-mode instead: no From, no Total, the note of
   snippets/ld-stone-unavailable.liquid. The delta stands in only when no size can be read at
   all. Read from input.disabled alone, never from option text (Easify translates the values). */
(function () {
	var SELECTOR = '.product__price.ld-price-panel[data-ld-from-delta]';
	var observer = null;

	function cents(text) {
		var m = (text || '').match(/\d[\d.,  ]*/);
		if (!m) return null;
		var s = m[0].replace(/[  ]+$/, '');
		var digits = s.replace(/\D/g, '');
		if (!digits) return null;
		return /[.,]\d{2}$/.test(s) ? parseInt(digits, 10) : parseInt(digits, 10) * 100;
	}
	function format(value, fmt) {
		var out;
		if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
			out = window.Shopify.formatMoney(value, fmt);
		} else {
			var whole = Math.floor(value / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
			out = fmt.replace(/\{\{\s*\w+\s*\}\}/, whole + ',' + ('0' + (value % 100)).slice(-2));
		}
		return out.replace(/€(?=\d)/g, '€ ');
	}
	function shown(input) {
		var holder = input.closest('label') || input.parentElement;
		return !input.closest('.tpo_hidden') && holder && holder.offsetParent !== null;
	}
	function update() {
		var panel = document.querySelector(SELECTOR);
		if (!panel) return;
		var scope = panel.closest('.shopify-section') || document;
		var delta = parseInt(panel.getAttribute('data-ld-from-delta'), 10) || 0;
		var base = parseInt(panel.getAttribute('data-ld-base'), 10) || 0;
		var notStones = (panel.getAttribute('data-ld-not-stone-products') || '').split(',').filter(Boolean);
		var fmt = (panel.getAttribute('data-ld-money-format') || '').trim() || '€ {{amount_with_comma_separator}}';
		var mine = panel.querySelector('.ld-from-amount');
		var spans = Array.prototype.filter.call(panel.querySelectorAll('.money--last'), function (el) { return el !== mine; });
		var app = spans.length > 1 ? spans.filter(function (el) { return el.style.display !== 'none'; })[0] : null;
		var total = app ? cents(app.textContent) : null;
		if (!mine || total === null) { panel.classList.remove('ld-from-mode', 'ld-none-mode'); return; }

		var stoneInputs = Array.prototype.filter.call(scope.querySelectorAll('input.tpo_buttons-input[data-product-id]'), function (input) {
			return notStones.indexOf(input.getAttribute('data-product-id')) === -1 && shown(input);
		});
		var chosen = stoneInputs.some(function (input) { return input.checked; });
		var onSale = false;
		var cheapest = null;
		stoneInputs.forEach(function (input) {
			if (input.disabled) return;
			onSale = true;
			var holder = (input.closest('label') || input).parentElement;
			var tip = holder && holder.querySelector('.tpo_buttons-tooltip');
			var price = tip ? cents(tip.textContent) : null;
			if (price !== null && (cheapest === null || price < cheapest)) cheapest = price;
		});
		var none = stoneInputs.length > 0 && !onSale && !chosen;
		var stone = cheapest !== null ? cheapest : delta;
		var from = !none && stone > 0 && !chosen && total - base < stone;
		if (from) {
			var text = format(total + stone, fmt);
			if (mine.textContent !== text) mine.textContent = text;
		}
		panel.classList.toggle('ld-from-mode', from);
		panel.classList.toggle('ld-none-mode', none);
	}
	function bind() {
		if (observer) observer.disconnect();
		observer = null;
		var panel = document.querySelector(SELECTOR);
		if (!panel) return;
		update();
		if (typeof MutationObserver !== 'undefined') {
			observer = new MutationObserver(update);
			observer.observe(panel, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style'] });
		}
	}
	bind();
	document.addEventListener('change', function () { setTimeout(update, 0); });
	document.addEventListener('tpo_loaded', function () { setTimeout(update, 0); });
	document.addEventListener('shopify:section:load', bind);
	/* Easify paints a beat after tpo_loaded on a cold cache */
	var tries = 0;
	var poll = setInterval(function () {
		tries += 1;
		update();
		if (tries > 20) clearInterval(poll);
	}, 500);
})();

/* Header scroll shadow — toggles .is-scrolled on the sticky header wrap */
(function () {
  var header = null;
  function onScroll() {
    if (!header) header = document.querySelector('.main-header-wrap');
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onScroll);
  } else {
    onScroll();
  }
})();

/* LD: "Postavke kolačića" footer menu item (href containing #ld-cookie-settings)
   reopens the native Shopify consent banner. Tries the current privacy-banner
   APIs in order; degrades to a console warning if the banner is not enabled. */
(function () {
	document.addEventListener('click', function (e) {
		const a = e.target.closest && e.target.closest('a[href*="#ld-cookie-settings"]');
		if (!a) return;
		e.preventDefault();
		try {
			if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); return; }
			if (window.privacyBanner && typeof window.privacyBanner.loadBanner === 'function') { window.privacyBanner.loadBanner(); return; }
			if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.openCookieBanner === 'function') { window.Shopify.customerPrivacy.openCookieBanner(); return; }
		} catch (err) { /* noop */ }
		console.warn('LD: consent banner API unavailable — enable the cookie banner in Settings → Customer privacy.');
	});
})();

/* LD: the legal-page accordions used to be driven from here. They are now native
   <details>/<summary> elements (see custom.css), so no script is involved. */


/* LD 2026-09-03: header language / country selector (snippets/ld-header-localization.liquid).
   The panel is a native <details>, so it opens, closes and submits with no script at all;
   this only adds the manners a dropdown is expected to have: close on a click or focus
   outside, on Escape (focus back on the trigger), when another instance opens, and when the
   header's live search opens (the theme fades the tools out under the search field, and an
   open panel would otherwise stay visible). Delegated on document, so it survives a
   theme-editor section reload. The click listener runs in the capture phase because the
   theme's nav <details> handler stops propagation (atlantic.js handleDetailClick) — a bubbling
   listener would never hear a click on a nav dropdown. */
(function () {
  var SELECTOR = 'details[data-ld-locale]';
  function closeAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (d) {
      if (d !== except && d.open) d.open = false;
    });
  }
  function owner(node) {
    return node && node.closest ? node.closest(SELECTOR) : null;
  }
  document.addEventListener('click', function (e) { closeAll(owner(e.target)); }, true);
  document.addEventListener('focusin', function (e) { closeAll(owner(e.target)); });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.matches && d.matches(SELECTOR) && d.open) closeAll(d);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR + '[open]'), function (d) {
      var hadFocus = d.contains(document.activeElement);
      var summary = d.querySelector('summary');
      d.open = false;
      if (hadFocus && summary) summary.focus();
    });
  });
  if (typeof MutationObserver === 'undefined') return;
  new MutationObserver(function () {
    if (document.documentElement.classList.contains('live-search-visible')) closeAll();
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
})();


/* LD 2026-09-04: Three-Stone rings — "Central Stone …" on the configurator labels.
   A three-stone ring carries a centre stone flanked by two side stones, so the bare
   "Stone Colour / Shape / Size" the Easify pickers render is ambiguous there. That
   option set also drives the solitaires, where the bare wording is the correct one,
   so the labels are rewritten for the products that need it instead of renamed in
   the app. snippets/ld-central-stone-labels.liquid emits the locale's from → to map
   and renders only for products in the "three-stone" collection — no map, no rewrite,
   so every other product is untouched. Keyed on the rendered label text because
   Easify translates option NAMES too (a German picker is named "Steinform Blanc
   Éternel"), which rules the name out as a locale-proof key. Idempotent: a rewritten
   label is never itself a key, so the observer cannot feed itself. Scoped to the
   marker's own container — the page also carries an empty .easify-product-options on
   every product card, and a card's ring may well be a solitaire. Re-applied on
   tpo_loaded, on Easify's own re-renders (it rebuilds the pickers whenever a
   conditional option shows or hides) and on a short poll for the first paint. */
(function () {
	var marker = document.querySelector('[data-ld-central-stone-labels]');
	if (!marker) return;
	var map;
	try {
		map = JSON.parse(marker.dataset.ldCentralStoneLabels || '{}');
	} catch (err) {
		return; /* malformed map: leave the app's own labels alone */
	}
	if (!map || !Object.keys(map).length) return;
	var scope = marker.parentElement;
	if (!scope) return;

	function apply() {
		var labels = scope.querySelectorAll('.easify-product-options .tpo_option-label .form__label');
		Array.prototype.forEach.call(labels, function (el) {
			var next = map[(el.textContent || '').trim()];
			if (next) el.textContent = next;
		});
	}

	apply();
	document.addEventListener('tpo_loaded', function () {
		setTimeout(apply, 0);
	});
	if (typeof MutationObserver !== 'undefined') {
		var timer = null;
		new MutationObserver(function () {
			clearTimeout(timer);
			timer = setTimeout(apply, 50);
		}).observe(scope, { subtree: true, childList: true });
	}
	/* Easify paints the pickers a beat after tpo_loaded on a cold cache */
	var tries = 0;
	var poll = setInterval(function () {
		tries += 1;
		apply();
		if (tries > 20) clearInterval(poll);
	}, 500);
})();


/* LD 2026-09-07, rebuilt 2026-10-20: the Easify "Prong setting agreement" - a REQUIRED checkbox Easify shows for the
   Pear and Marquise shapes (set 174447) - only concerns 4-prong rings, tagged 4prongs; there Easify shows and enforces
   it untouched. For every other product snippets/ld-prong-agreement-gate.liquid emits a marker (and a first-paint
   <style>); this puts Easify's own tpo_hidden class on that option's .tpo_option-container and disables its inputs -
   the no-resize gate below, same mechanism. Easify's validator skips a tpo_hidden container (no required check) and
   disables its properties[] inputs before new FormData(form) builds the payload, and a disabled input is never
   submitted, so the box is never seen, never ticked and never reaches the cart, checkout or the e-mails. NEVER
   ticked: until 2026-10-20 this gate ticked the hidden box, which put an "I agree ..." the customer never saw on the
   orders of every non-4-prong ring with a pear or marquise stone. Easify's conditions remove tpo_hidden (and
   re-enable the input) when Pear / Marquise is picked; the observer puts it back before the next paint and the
   capture-phase listeners before Easify's add-to-cart validation. The ld-prong-gated mark is hidden by custom.css as
   well. Easify also validates in the shape click's own handler, right after its conditions and before the observer
   runs (ut(Pe()): the tpo-validated-form attribute its CSS uses to block Buy-it-now), so the inputs are made
   non-required (data-required 0) and the error text uc() writes on every add-to-cart click is cleared: a box that is
   visible for that one moment then neither fails nor leaves the form marked invalid.
   Found language-independently: the marker's English identifier is looked up in window.TPOConfigs (Easify keeps
   product_options_easify untranslated; only the uuid matters) and the container id is "<per-render uuid>,<option
   uuid>,checkbox", so only its last two parts are compared. The translated names on the marker are the fallback
   (the hidden input's properties[<name>]) for a render whose options did not come from TPOConfigs. Idempotent -
   the DOM is written only where it differs - so the observer cannot feed itself, and it runs synchronously in the
   observer callback, before the next paint. Re-applied on tpo_loaded, on Easify's re-renders and class changes
   (MutationObserver), on a short poll for the first paint, and in the capture phase of every click and submit,
   i.e. ahead of Easify's own add-to-cart click handler and its validator. Scoped to the marker's
   container - product cards carry empty .easify-product-options too. */
(function () {
	var marker = document.querySelector('[data-ld-prong-gate]');
	if (!marker) return;
	function list(s) {
		return (s || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
	}
	var idents = list(marker.dataset.ldPgIdentifiers);
	var knownIds = list(marker.dataset.ldPgIds);
	var names = list(marker.dataset.ldPgNames);
	if (!idents.length && !knownIds.length && !names.length) return;
	var scope = marker.parentElement || document;
	var HIDDEN = 'tpo_hidden'; /* Easify's own class: display:none and skipped by its validator */
	var MARK = 'ld-prong-gated';
	var SETS = ['product_options_easify', 'product_options', 'product_options_1', 'product_options_2',
		'product_options_3', 'product_options_4', 'product_options_tpo'];

	function optionIds() {
		var ids = knownIds.slice();
		var cfg = window.TPOConfigs || {};
		SETS.forEach(function (key) {
			var sets = cfg[key];
			if (!sets || !sets.length) return;
			Array.prototype.forEach.call(sets, function (set) {
				var opts = (set && set.option_set && set.option_set.options) || [];
				Array.prototype.forEach.call(opts, function (o) {
					if (!o || !o.id || o.type !== 'checkbox' || ids.indexOf(o.id) !== -1) return;
					var ident = String(o.option_identifier || '').trim();
					var title = String(o.title || '').trim();
					/* English identifiers in the untranslated config; translated names only in product_options_tpo */
					var keys = key === 'product_options_tpo' ? idents.concat(names) : idents;
					if (keys.indexOf(ident) !== -1 || keys.indexOf(title) !== -1) ids.push(o.id);
				});
			});
		});
		return ids;
	}

	function byId(c, ids) {
		var parts = (c.id || '').split(',');
		return parts.length >= 3 && parts[parts.length - 1] === 'checkbox' && ids.indexOf(parts[parts.length - 2]) !== -1;
	}

	function byName(c) {
		var inp = c.querySelector('input.tpo_hidden-checkbox');
		if (!inp || inp.closest('.tpo_option-container') !== c) return false;
		var m = /^properties\[_?(.*)\]$/.exec(inp.name || '');
		return !!m && names.indexOf(m[1].trim()) !== -1;
	}

	function gate() {
		var ids = null;
		var all = scope.querySelectorAll('.easify-product-options .tpo_option-container, .product__app .tpo_option-container');
		Array.prototype.forEach.call(all, function (c) {
			if (!c.classList.contains(MARK)) {
				if (ids === null) ids = optionIds();
				if (!byId(c, ids) && !byName(c)) return;
				c.classList.add(MARK);
			}
			if (!c.classList.contains(HIDDEN)) c.classList.add(HIDDEN);
			Array.prototype.forEach.call(c.querySelectorAll('input, textarea'), function (inp) {
				if (!inp.disabled) inp.disabled = true; /* never submitted, and skipped by the required check */
				if (inp.dataset.required && inp.dataset.required !== '0') inp.dataset.required = '0';
			});
			Array.prototype.forEach.call(c.querySelectorAll('.tpo_error-message'), function (e) {
				if (e.innerHTML) e.innerHTML = '';
			});
		});
	}

	gate();
	document.addEventListener('tpo_loaded', function () { gate(); setTimeout(gate, 0); });
	/* right before Easify validates and builds the payload (capture phase, ahead of the button's and the form's
	   handlers); any click or submit, wherever its button sits - gate() is idempotent and cheap */
	document.addEventListener('click', gate, true);
	document.addEventListener('submit', gate, true);
	if (typeof MutationObserver !== 'undefined') {
		new MutationObserver(gate).observe(scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
	}
	var tries = 0;
	var poll = setInterval(function () {
		tries += 1;
		gate();
		if (tries > 20) clearInterval(poll);
	}, 500);
})();


/* LD 2026-10-20: the Easify "Resizing not possible" agreement - a REQUIRED checkbox without conditions (since
   2026-10-22 only in the "Ring (No central stone)" set 208074, which also holds the resizable Stackables) - belongs
   only to the rings flagged lediameve.no_resize = true (since 2026-10-22, Niko: the Eternity Bands R401-R408 only);
   there Easify shows and enforces it untouched. For every other product snippets/ld-resize-agreement-gate.liquid emits a marker (and a
   first-paint <style>); this puts Easify's own tpo_hidden class on that option's .tpo_option-container and
   disables its inputs. Easify's validator skips a tpo_hidden container (no required check) and disables its
   properties[] inputs before new FormData(form) builds the payload, and a disabled input is never submitted, so
   the box is never seen, never ticked and never reaches the cart, checkout or the e-mails. NEVER ticked (nor is
   the prong agreement above): "cannot be resized" on a resizable ring's order would contradict Terms 16.4.
   Found language-independently: the marker's English identifiers are looked up in window.TPOConfigs (Easify keeps
   product_options_easify untranslated; only the uuid matters) and the container id is "<per-render uuid>,<option
   uuid>,checkbox", so only its last two parts are compared. The translated names on the marker are the fallback
   (the hidden input's properties[<name>]) for a render whose options did not come from TPOConfigs. Idempotent -
   the DOM is written only where it differs - so the observer cannot feed itself, and it runs synchronously in the
   observer callback, before the next paint. Re-applied on tpo_loaded, on Easify's re-renders and class changes
   (MutationObserver), on a short poll for the first paint, and in the capture phase of every click and submit,
   i.e. ahead of Easify's own add-to-cart click handler and its validator. Scoped to the marker's
   container - product cards carry empty .easify-product-options too. */
(function () {
	var marker = document.querySelector('[data-ld-resize-gate]');
	if (!marker) return;
	function list(s) {
		return (s || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
	}
	var idents = list(marker.dataset.ldNrIdentifiers);
	var knownIds = list(marker.dataset.ldNrIds);
	var names = list(marker.dataset.ldNrNames);
	if (!idents.length && !knownIds.length && !names.length) return;
	var scope = marker.parentElement || document;
	var HIDDEN = 'tpo_hidden'; /* Easify's own class: display:none and skipped by its validator */
	var MARK = 'ld-nr-gated';
	var SETS = ['product_options_easify', 'product_options', 'product_options_1', 'product_options_2',
		'product_options_3', 'product_options_4', 'product_options_tpo'];

	function optionIds() {
		var ids = knownIds.slice();
		var cfg = window.TPOConfigs || {};
		SETS.forEach(function (key) {
			var sets = cfg[key];
			if (!sets || !sets.length) return;
			Array.prototype.forEach.call(sets, function (set) {
				var opts = (set && set.option_set && set.option_set.options) || [];
				Array.prototype.forEach.call(opts, function (o) {
					if (!o || !o.id || o.type !== 'checkbox' || ids.indexOf(o.id) !== -1) return;
					var ident = String(o.option_identifier || '').trim();
					var title = String(o.title || '').trim();
					/* English identifiers in the untranslated config; translated names only in product_options_tpo */
					var keys = key === 'product_options_tpo' ? idents.concat(names) : idents;
					if (keys.indexOf(ident) !== -1 || keys.indexOf(title) !== -1) ids.push(o.id);
				});
			});
		});
		return ids;
	}

	function byId(c, ids) {
		var parts = (c.id || '').split(',');
		return parts.length >= 3 && parts[parts.length - 1] === 'checkbox' && ids.indexOf(parts[parts.length - 2]) !== -1;
	}

	function byName(c) {
		var inp = c.querySelector('input.tpo_hidden-checkbox');
		if (!inp || inp.closest('.tpo_option-container') !== c) return false;
		var m = /^properties\[_?(.*)\]$/.exec(inp.name || '');
		return !!m && names.indexOf(m[1].trim()) !== -1;
	}

	function gate() {
		var ids = null;
		var all = scope.querySelectorAll('.easify-product-options .tpo_option-container, .product__app .tpo_option-container');
		Array.prototype.forEach.call(all, function (c) {
			if (!c.classList.contains(MARK)) {
				if (ids === null) ids = optionIds();
				if (!byId(c, ids) && !byName(c)) return;
				c.classList.add(MARK);
			}
			if (!c.classList.contains(HIDDEN)) c.classList.add(HIDDEN);
			Array.prototype.forEach.call(c.querySelectorAll('input, textarea'), function (inp) {
				if (!inp.disabled) inp.disabled = true; /* never submitted, and skipped by the required check */
			});
		});
	}

	gate();
	document.addEventListener('tpo_loaded', function () { gate(); setTimeout(gate, 0); });
	/* right before Easify validates and builds the payload (capture phase, ahead of the button's and the form's
	   handlers); any click or submit, wherever its button sits - gate() is idempotent and cheap */
	document.addEventListener('click', gate, true);
	document.addEventListener('submit', gate, true);
	if (typeof MutationObserver !== 'undefined') {
		new MutationObserver(gate).observe(scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
	}
	var tries = 0;
	var poll = setInterval(function () {
		tries += 1;
		gate();
		if (tries > 20) clearInterval(poll);
	}, 500);
})();


/* LD 2026-10-02: per-line engraving flag. An engraved ring has no right of withdrawal, whatever its category
   (decision of 2026-10-02; clearly personalised goods, ZZP čl. 86 st. 1 t. 3 / CRD Art 16(c)), and engraving is
   chosen per order line with the Easify checkbox option "Engraving", so the per-product category metafield
   cannot say it. snippets/ld-engraving-flag.liquid emits a marker carrying that option's NAME in each storefront
   language - Easify translates names, so the checkbox id "<name>-0" and the label
   text vary per locale; option VALUES are never matched, they are translated too. While the box is ticked this
   keeps a hidden properties[_ld_engraved]=1 inside the product form and switches the hidden Category property
   (snippets/ld-category-property.liquid: data-ld-cat-base / data-ld-cat-engraved) to its engraved text; unticked,
   the flag is removed and the base text restored. The cart line (snippets/ld-cart-category.liquid), the checkout
   property and the order e-mails read the result. Idempotent - the DOM is written only where it differs from the
   wanted state - so its own writes can never feed an observer into a loop. Synced on every change of a checkbox
   in scope, on tpo_loaded, on Easify's re-renders (MutationObserver), on a short poll for the first paint and -
   so the payload is right at the moment it leaves - again in the capture phase of any click inside the product
   form (Easify's cloned add-to-cart button builds new FormData(form) in its own click handler, which runs after
   a capture listener on document) and of the form's submit event (native or dispatched). Scoped to the marker's
   container - product cards carry empty .easify-product-options too. */
(function () {
	var marker = document.querySelector('[data-ld-engraving-flag]');
	if (!marker) return;
	var names = (marker.dataset.ldEngravingNames || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
	if (!names.length) return;
	var scope = marker.parentElement || document;
	var FLAG = 'properties[_ld_engraved]';

	function blockOf(cb) {
		return cb.closest('[class*="tpo_option-type-"]') || cb.closest('.tpo_option-label');
	}

	function isEngraving(cb) {
		var id = cb.id || '';
		for (var i = 0; i < names.length; i++) {
			if (id === names[i] + '-0' || id.indexOf(names[i] + '-') === 0) return true;
		}
		var block = blockOf(cb);
		var label = block && block.querySelector('.form__label');
		var text = label ? label.textContent.replace(/\*/g, '').trim() : '';
		return !!text && names.indexOf(text) !== -1;
	}

	function engraved() {
		var boxes = scope.querySelectorAll('.easify-product-options input[type="checkbox"]');
		for (var i = 0; i < boxes.length; i++) {
			if (boxes[i].checked && !boxes[i].disabled && isEngraving(boxes[i])) return true;
		}
		return false;
	}

	function sync() {
		var on = engraved();
		var forms = scope.querySelectorAll('form[data-product-form], form.shopify-product-form');
		Array.prototype.forEach.call(forms, function (form) {
			var flag = form.querySelector('input[name="' + FLAG + '"]');
			if (on) {
				if (!flag) {
					flag = document.createElement('input');
					flag.type = 'hidden';
					flag.name = FLAG;
					flag.value = '1';
					form.appendChild(flag);
				} else if (flag.value !== '1') {
					flag.value = '1';
				}
			} else if (flag && flag.parentNode) {
				flag.parentNode.removeChild(flag);
			}
			var cat = form.querySelector('input[data-ld-category-property]');
			if (cat) {
				var want = cat.getAttribute(on ? 'data-ld-cat-engraved' : 'data-ld-cat-base');
				if (want && cat.value !== want) cat.value = want;
			}
		});
	}

	sync();
	document.addEventListener('tpo_loaded', function () { setTimeout(sync, 0); });
	/* a tick or untick of an option box: its checked state is final by the time change fires */
	document.addEventListener('change', function (e) {
		var t = e.target;
		if (t && t.type === 'checkbox' && scope.contains(t)) sync();
	}, true);
	/* right before the payload leaves (capture phase, so ahead of the button's and the form's own handlers) */
	document.addEventListener('click', function (e) {
		var form = e.target && e.target.closest ? e.target.closest('form') : null;
		if (form && scope.contains(form)) sync();
	}, true);
	document.addEventListener('submit', function (e) {
		if (e.target && scope.contains(e.target)) sync();
	}, true);
	if (typeof MutationObserver !== 'undefined') {
		var timer = null;
		new MutationObserver(function () {
			clearTimeout(timer);
			timer = setTimeout(sync, 50);
		}).observe(scope, { subtree: true, childList: true });
	}
	var tries = 0;
	var poll = setInterval(function () {
		tries += 1;
		sync();
		if (tries > 20) clearInterval(poll);
	}, 500);
})();


/* LD 2026-09-09: "Find your ring size" — the theme-owned sizing modal (snippets/ld-sizing-tool.liquid).
   Easify's own sizing link opens an app-side popup the theme can neither style nor translate, so the
   snippet renders a native <dialog> and this seats the trigger where the app's link sits, right under
   the Ring Size dropdown. Primary anchor: the app's .tpo_open-modal-button (class-based, locale-proof),
   hidden with a class only once our trigger is actually in place — no JS, no snippet, and Easify's own
   popup keeps working (graceful degradation). Fallback anchor when that class is gone: the option whose
   label starts with a localized Ring Size name the trigger carries (data-ld-names — both the
   "Select Ring Size" wording of the central-stone set and the bare "Ring Size" of the
   no-central-stone set, in all six languages). Without
   <dialog> support the trigger simply follows its href to the Choosing-ring-size page. The dialog stays
   where it renders — showModal() lifts it to the top layer. Quickshop is untouched (the snippet renders
   on the product page only). Idempotent: seating checks the trigger's current position, so Easify
   re-renders can never make it loop. Re-applied on tpo_loaded, on Easify's re-renders and on a short
   poll for the first paint, like the other gates. */
(function () {
	var dialog = document.querySelector('dialog[data-ld-sizing-tool]');
	var trigger = document.querySelector('[data-ld-sizing-trigger]');
	if (!dialog || !trigger) return;
	var scope = trigger.parentElement || document;
	var names = (trigger.dataset.ldNames || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);

	/* LD 2026-09-09 (2): the sizing-tool option was removed in the Easify admin, so the
	   .tpo_open-modal-button anchor is normally absent and the label route is the primary
	   path. There is no static per-option wrapper around the dropdown control
	   (.tpo_option-type-dropdown-wrapper is the floating list, not a container): the label
	   row (.tpo_option-label) and the control are siblings, so the trigger seats after the
	   first following sibling that holds the dropdown input — never inline in the label row,
	   which is where the first version landed when its wrapper lookup missed. */
	function seat() {
		var btn = scope.querySelector('.easify-product-options .tpo_open-modal-button');
		if (btn) return { el: btn, how: 'after', appLink: true };
		var rows = scope.querySelectorAll('.easify-product-options .tpo_option-label');
		for (var i = 0; i < rows.length; i++) {
			var text = (rows[i].textContent || '').replace(/\*/g, '').trim();
			var hit = false;
			for (var j = 0; j < names.length; j++) {
				if (text.indexOf(names[j]) === 0) { hit = true; break; }
			}
			if (!hit) continue;
			var sib = rows[i].nextElementSibling;
			while (sib) {
				if (sib !== trigger) {
					if (sib.classList && sib.classList.contains('tpo_option-label')) break; /* next option reached */
					var isControl = sib.matches && sib.matches('input.tpo_option-dropdown, select');
					if (!isControl && sib.querySelector) isControl = !!sib.querySelector('input.tpo_option-dropdown, select');
					if (isControl) return { el: sib, how: 'after' };
				}
				sib = sib.nextElementSibling;
			}
			/* no control between this label and the next: settle for the end of the block */
			return { el: rows[i].parentElement, how: 'append' };
		}
		return null;
	}

	function place() {
		var s = seat();
		if (!s || !s.el) return;
		if (s.appLink) s.el.classList.add('ld-sizing-app-link-hidden');
		if (s.how === 'append') {
			if (s.el.lastElementChild !== trigger) s.el.appendChild(trigger);
		} else if (s.el.nextElementSibling !== trigger) {
			s.el.insertAdjacentElement('afterend', trigger);
		}
		trigger.hidden = false;
	}

	/* LD 2026-09-10: display-only enrichment of the Ring Size picker. The stored option values
	   stay canonical bare numbers (order exports, the translation CSV and the locale-proof JS
	   all depend on that); this decorates what the shopper SEES while choosing: the input's
	   generic "Select an option" placeholder becomes the locale's "Your EU size", and every row
	   of the open list gains a muted right-aligned hint — the inner diameter in mm, or the
	   national size on the it/es storefronts. Hints arrive pre-localized on the dialog
	   (data-ld-picker-hints, built by the snippet from the same chart as the modal). Easify
	   renders and re-renders the list rows lazily, so adorn() rides the same observer,
	   tpo_loaded hook and poll as place(); idempotent per row via data-ld-hinted. */
	var hints = {};
	(dialog.dataset.ldPickerHints || '').split('|').forEach(function (pair) {
		var i = pair.indexOf(':');
		if (i > 0) hints[pair.slice(0, i)] = pair.slice(i + 1);
	});
	var pickerPh = dialog.dataset.ldPickerPh || '';

	function adorn() {
		var box = trigger.parentElement;
		if (!box) return;
		var input = box.querySelector('input.tpo_option-dropdown');
		if (!input) return;
		if (pickerPh) {
			var ph = input.getAttribute('placeholder') || '';
			if (ph.indexOf(pickerPh) !== 0) {
				var star = /\*\s*$/.test(ph) ? ' *' : '';
				input.setAttribute('placeholder', pickerPh + star);
			}
		}
		var wrap = input.parentElement && input.parentElement.nextElementSibling;
		if (!wrap || !wrap.className || wrap.className.indexOf('tpo_option-type-dropdown-wrapper') === -1) return;
		var rows = wrap.querySelectorAll('button.tpo_option-type-selection');
		Array.prototype.forEach.call(rows, function (btn) {
			if (btn.dataset.ldHinted) return;
			var value = (btn.textContent || '').trim();
			var hint = hints[value];
			/* no flag on a miss: rows render lazily and the option values may still be migrating
			   to the EU scale — re-checked on the next debounced pass, which costs nothing */
			if (!hint) return;
			btn.dataset.ldHinted = '1';
			var span = document.createElement('span');
			span.className = 'ld-size-hint';
			span.textContent = hint;
			btn.appendChild(span);
		});
	}

	function apply() {
		place();
		adorn();
	}

	trigger.addEventListener('click', function (e) {
		if (typeof dialog.showModal !== 'function') return; /* no <dialog>: follow the href to the guide page */
		e.preventDefault();
		dialog.showModal();
	});
	dialog.addEventListener('click', function (e) {
		/* a click on the ::backdrop lands on the dialog element itself */
		if (e.target === dialog) dialog.close();
	});
	var sizingClose = dialog.querySelector('[data-ld-sizing-close]');
	if (sizingClose) sizingClose.addEventListener('click', function () { dialog.close(); });

	apply();
	document.addEventListener('tpo_loaded', function () { setTimeout(apply, 0); });
	if (typeof MutationObserver !== 'undefined') {
		var placeTimer = null;
		new MutationObserver(function () {
			clearTimeout(placeTimer);
			placeTimer = setTimeout(apply, 50);
		}).observe(scope, { subtree: true, childList: true });
	}
	var placeTries = 0;
	var placePoll = setInterval(function () {
		placeTries += 1;
		apply();
		if (placeTries > 20) clearInterval(placePoll);
	}, 500);
})();


/* LD 2026-09-11: geolocation recommendation banner (snippets/ld-locale-banner.liquid).
   Shopify's recommended pattern — suggest, never auto-redirect: the storefront endpoint
   browsing_context_suggestions.json reads the visitor's IP and browser language SERVER-side
   and answers with a better country/language when the store publishes one, already excluding
   the rendered context via the exclude params (re-checked here anyway). Only then is the
   banner revealed. Accepting submits the snippet's localization form (country_code /
   locale_code prefilled below) — the same mechanism as the header selector, so Shopify
   computes the localized return_to itself. Suggested names arrive in the SUGGESTED language
   ("Français"), which is the version the visitor recognises; the page-language copy comes
   from the snippet's data-template-* attributes ([name] token).
   Dismissal memory (localStorage, fails open in private mode):
     "*"          — any explicit localization-form submit, header selector or banner: a
                    visitor who chose a context is not nagged about their IP. 90 days.
     "CC|lang"    — the banner's own dismiss: that one suggestion stays hidden, so a
                    DIFFERENT suggestion (travel) may still show. 30 days. */
(function () {
	var banner = document.querySelector('[data-ld-locale-banner]');
	if (!banner || !window.fetch) return;

	var KEY = 'ld-locale-banner';
	var CHOSE_MS = 90 * 24 * 60 * 60 * 1000;
	var DISMISSED_MS = 30 * 24 * 60 * 60 * 1000;

	function readStore() {
		try { return JSON.parse(window.localStorage.getItem(KEY)); } catch (err) { return null; }
	}
	function writeStore(value) {
		try { window.localStorage.setItem(KEY, JSON.stringify({ v: value, t: Date.now() })); } catch (err) { /* noop */ }
	}
	function suppressed(suggestionKey) {
		var s = readStore();
		if (!s || !s.v || typeof s.t !== 'number') return false;
		if (s.v === '*') return Date.now() - s.t < CHOSE_MS;
		return s.v === suggestionKey && Date.now() - s.t < DISMISSED_MS;
	}

	/* capture phase: atlantic.js stops propagation inside the header, and intent counts
	   even if something downstream prevented the submit */
	document.addEventListener('submit', function (e) {
		var form = e.target;
		if (form && typeof form.action === 'string' && form.action.indexOf('/localization') !== -1) writeStore('*');
	}, true);

	if (suppressed('')) return; /* matches only the stored "*" — an explicit earlier choice */

	function endonym(name) {
		return name ? name.charAt(0).toUpperCase() + name.slice(1) : name;
	}

	var root = banner.getAttribute('data-root') || '/';
	var url = root + 'browsing_context_suggestions.json'
		+ '?country[enabled]=true&country[exclude]=' + encodeURIComponent(banner.getAttribute('data-country') || '')
		+ '&language[enabled]=true&language[exclude]=' + encodeURIComponent(banner.getAttribute('data-language') || '');

	fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
		var parts = data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts;
		if (!parts) return;
		var country = parts.country && parts.country.handle ? parts.country : null;
		var language = parts.language && parts.language.handle ? parts.language : null;
		if (country && country.handle === banner.getAttribute('data-country')) country = null;
		if (language && language.handle === banner.getAttribute('data-language')) language = null;
		if (!country && !language) return;

		var suggestionKey = (country ? country.handle : '') + '|' + (language ? language.handle : '');
		if (suppressed(suggestionKey)) return;

		var currencies = {};
		try { currencies = JSON.parse(banner.querySelector('[data-ld-locale-banner-currencies]').textContent) || {}; } catch (err) { /* noop */ }

		var targetBits = [];
		if (language) targetBits.push(endonym(language.name));
		if (country) targetBits.push(country.name + (currencies[country.handle] ? ' (' + currencies[country.handle] + ')' : ''));
		banner.querySelector('[data-ld-locale-banner-target]').textContent = targetBits.join(' · ');

		var message = country
			? (banner.getAttribute('data-template-country') || '').replace('[name]', country.name)
			: (banner.getAttribute('data-template-language') || '').replace('[name]', endonym(language.name));

		if (country) banner.querySelector('[data-ld-locale-banner-country]').value = country.handle;
		if (language) banner.querySelector('[data-ld-locale-banner-locale]').value = language.handle;

		Array.prototype.forEach.call(banner.querySelectorAll('[data-ld-locale-banner-dismiss]'), function (btn) {
			btn.addEventListener('click', function () {
				banner.hidden = true;
				writeStore(suggestionKey);
			});
		});

		setTimeout(function () {
			banner.hidden = false;
			/* the role=status region only announces text set while visible */
			requestAnimationFrame(function () {
				banner.querySelector('[data-ld-locale-banner-message]').textContent = message;
			});
		}, 400);
	}).catch(function () { /* noop — no banner is the correct fallback */ });
})();
